'use strict';
import React from 'react';
import {connect} from 'react-redux';
import TopUserInfo from './TopUserInfo.jsx';

class Header extends React.Component {
  constructor(props, context) {
    super(props, context);

  }

  componentDidMount() {
    // console.log('Something goes here');
  }

  render() {
    return (
      <header className="main-header">
        <a href="index2.html" className="logo">
          <span className="logo-mini"><b>A</b>LT</span>
          <span className="logo-lg"><b>Admin</b>LTE</span>
        </a>
        <nav className="navbar navbar-static-top">
          <a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
            <span className="sr-only">Toggle navigation</span>
          </a>

          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              {
                <TopUserInfo/>
              }
              <li>
                <a href="#" data-toggle="control-sidebar"><i className="fa fa-gears"></i></a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }

}

export default connect()(Header);



// WEBPACK FOOTER //
// ./components/layouts/main/Header.jsx